import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.assignedList

// This saga is for getting specific assigned list companies
function* assignedListSagaTask({ payload }) {
    const params = yield getParams(payload)
    try {
        const response = yield axios.get(`/companies/assigned-list`, {
            params
        })
        if (response.success) {
            yield put(onSuccess({ noSaveInStore: payload.noSaveInStore, ...response.result }))
            yield put(payload?.sagaCB?.onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* assignedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, assignedListSagaTask)
}

export default assignedListSaga
